import { KompendiumConfig } from '../types';

export const defaultConfig: KompendiumConfig = {
    path: '.kompendium',
    publicPath: 'www',
    typeRoot: './src/types.ts',
    guides: [],
};
